var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTypeleft = function SvgTypeleft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.455 19.35 3.707 12.6H21a.5.5 0 0 0 0-1H3.707l6.748-6.747a.5.5 0 1 0-.707-.708l-7.602 7.602a.5.5 0 0 0 0 .707l7.602 7.601a.5.5 0 1 0 .707-.707Z",
    fill: "currentColor"
  })));
};
export { SvgTypeleft as ReactComponent };
export default __webpack_public_path__ + "3576d81cffab4f65616c26b2f37295d7.svg";